import {UFBNoticeClickEvent, UFBNoticeImpressionEvent} from '@udemy/browse-event-tracking';
import {Tracker} from '@udemy/event-tracking';
import {SubscriptionPlan, SubscriptionPlanProductType} from '@udemy/subscription-graphql';

import {
    SubscriptionLearnMoreEvent,
    SubscriptionOfferPresented,
} from 'src/events/subscription-events';

export const UI_REGION_MAIN = 'main';
export const UI_REGION_COMPARE_PLAN = 'compare_plan';

export const trackSubscriptionCtaClick = (
    productType: SubscriptionPlanProductType,
    plan?: SubscriptionPlan,
) => {
    if (plan) {
        const planPriceIds = plan.priceOptions.map((option) => option.id);
        Tracker.publishEvent(
            new SubscriptionLearnMoreEvent({
                planId: planPriceIds[0],
                planPriceIds: planPriceIds,
                planType: productType,
                uiRegion: 'plan_comparison_matrix',
            }),
        );
    }
};

export const trackSubscriptionImpression = (
    countryCode: string,
    productType: SubscriptionPlanProductType,
    plan?: SubscriptionPlan,
    uiRegion = UI_REGION_COMPARE_PLAN,
) => {
    if (plan) {
        Tracker.publishEvent(
            new SubscriptionOfferPresented({
                subscriptionPlan: plan,
                productType: productType,
                countryCode,
                uiRegion,
            }),
        );
    }
};

export const trackOrganizationCtaClickEvent = (url: string, locale: string) => {
    Tracker.publishEvent(
        new UFBNoticeClickEvent({
            url,
            placement: 'compare_plans_and_features',
            locale,
        }),
    );
};

export const trackOrganizationImpression = (url: string, locale: string) => {
    Tracker.publishEvent(
        new UFBNoticeImpressionEvent({
            locale,
            placement: 'compare_plans_and_features',
            url,
        }),
    );
};
